export default "__VITE_ASSET__DzlMqvd7__"